import * as React from 'react';
import dateFormat = require('dateformat');
import { capitalise, dangerousInnerHtml } from '../utils';

interface SelectedProps {
	criteria: Array<filter>,
	keywordSubmit: filter,
	onRemoveSelected: (crIndex: number, type: string, subAttr?: string) => void,
	onReset: () => void
}

interface TaxItemProps {
	key: number,
	title: string,
	content?: string,
	reset?: () => void,
	onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
}

const FilterTaxItem: React.SFC<TaxItemProps> = ({key, onClick = null, title, content = null, reset = null}) => (
	<span className="search__filter__tax-item" key={key} onClick={reset}>
		<span dangerouslySetInnerHTML={dangerousInnerHtml(`${capitalise(title)}${!!content ? `: ${content}` : ''}`)}/>
		<svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" onClick={onClick}>
			<g id="Search---Articles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
				<g id="Articles-Search---2400" transform="translate(-1052.000000, -273.000000)" stroke="#559b43" stroke-width="4">
					<g id="Remove-Filter-X" transform="translate(1054.000000, 275.000000)">
						<path d="M8.48528137,-1.0658141e-14 L6.92779167e-14,8.48528137" id="Line"></path>
						<path d="M8.67147268,-1.0658141e-14 L0.186191302,8.48528137" id="Line" transform="translate(4.428832, 4.242641) scale(-1, 1) translate(-4.428832, -4.242641) "></path>
					</g>
				</g>
			</g>
		</svg>
	</span>
)

export const ResultSelected: React.SFC<SelectedProps> = ({criteria, keywordSubmit, onRemoveSelected, onReset}) => {
	let showReset = false;

	const filterGroup = criteria.map(filter => {
		if (filter.type === 'text') {
			return keywordSubmit;
		} else if (filter.type !== 'text') {
			return filter;
		}
	});

    return (
        <div className="facet-in-result-criteria">

			<div className="search__filter__tax-item-container">

                {filterGroup.length > 0 && filterGroup.map((filter, index) => {
					if (!!filter.data) showReset = !!filter.data.text;
					return (
						<>
							{filter.type === 'text' && filter.data && <FilterTaxItem key={index} title={filter.name} content={filter.data.text} onClick={onRemoveSelected.bind(this, index, filter.type)}/>}
							{filter.type === 'date' &&
								<>
									{Object.keys(filter.date).map((key, i) => {
										if (filter.date[key]) showReset = true;
										return (
											filter.date[key] &&
											<FilterTaxItem key={index + i * 100} title={key === 'from' ? 'after' : 'before'} content={dateFormat(filter.date[key], 'dd/mm/yyyy')} onClick={onRemoveSelected.bind(this, index, filter.type, key)}/>
										)
									})}
								</>
							}
							{filter.type === 'tax' && filter.terms.map((term, i) => {
								if (term.checked && term.taxonomy !== 'status_tax') showReset = true;
								if (!term.checked && term.taxonomy === 'status_tax') showReset = true;
								return (
									term.checked &&
									<FilterTaxItem key={index + i * 100} title={term.name} onClick={onRemoveSelected.bind(this, index, filter.type, i)}/>
								)
							})}
						</>
					)
				})}

				{showReset && <FilterTaxItem key={Math.random()*1000} title={'Reset'} reset={onReset}/>}

			</div>

		</div>
    )
}
